/* eslint-disable */
export default {
    name: 'Footer',
    setup() {
    }
};